import { useMutation } from "@tanstack/react-query";
import { X } from "lucide-react";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { updateCustomSnippetsUrl } from "@/zapi-frontend/pages/SettingsPage/services/updateCustomSnippetsUrl";
import { AppButton, FigmaTypography } from "@libs/zapi-ui/custom";

export function CustomSnippetsBanner() {
  const { customSnippetsUrl, setMe } = useMeStore();

  const mutation = useMutation({
    mutationFn: updateCustomSnippetsUrl,
    onSuccess: () => {
      setMe({ customSnippetsUrl: null });
    }
  });

  const handleClear = () => {
    mutation.mutate({ customSnippetsUrl: null });
  };

  if (!customSnippetsUrl) return null;

  return (
    <div className="bg-red-100 border-l-4 border-red-500 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <FigmaTypography variant="body-2" className="text-red-800">
          You're currently using custom snippets URL (MAY CAUSE ERRORS IF CONFIGURED INCORRECTLY):{" "}
          <span className="font-medium">{customSnippetsUrl}</span>
        </FigmaTypography>
      </div>
      <AppButton
        size="sm"
        appearance="outlined"
        onClick={handleClear}
        disabled={mutation.isPending}
        className="flex items-center gap-2 text-red-600 border-red-200 hover:bg-red-50 bg-white"
      >
        {mutation.isPending ? (
          <>
            <div className="w-4 h-4 border-2 border-red-600 border-t-transparent rounded-full animate-spin"></div>
            Resetting...
          </>
        ) : (
          <>
            <X className="w-4 h-4" />
            Reset to default
          </>
        )}
      </AppButton>
    </div>
  );
}
